import {
  getLeadChangeReasonLabel,
  getPrimaryChangeReason,
} from './lead-change-reason.enum';
import { LeadStatus } from './lead-status.enum';

export enum LeadType {
  INSURANCE = 'LEAD',
  CLAIM = 'CLAIM',
  /** A cancellation of the new aggregate, which is no kind of lead. */
  CANCELLATION = 'CANCELLATION',
  POLICY = 'POLICY',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  SUBMISSION = 'SUBMISSION',
  PROPOSAL = 'PROPOSAL',
}

export const getLeadTypeLabel = (
  value: LeadType,
  changeReason: string | string[] = ''
): string => {
  const primaryChangeReason = getPrimaryChangeReason(changeReason);
  switch (value) {
    case LeadType.CLAIM:
      return $localize`Sinistre`;
    case LeadType.CANCELLATION:
      return $localize`Résiliation`;
    case LeadType.INSURANCE:
      return `${$localize`Lead`} ${getLeadChangeReasonLabel(primaryChangeReason)}`;
    case LeadType.POLICY:
      return $localize`Police`;
    case LeadType.OFFER_ACCEPTED:
      return `${$localize`Contrats à soumettre`} ${getLeadChangeReasonLabel(primaryChangeReason)}`;
    case LeadType.SUBMISSION:
      return `${$localize`Contrats soumis`} ${getLeadChangeReasonLabel(primaryChangeReason)}`;
    case LeadType.PROPOSAL:
      return `${$localize`Proposition`} ${getLeadChangeReasonLabel(primaryChangeReason)}`;
    default:
      return '';
  }
};

export const getLeadTypeClass = (value: LeadType): string => {
  switch (value) {
    case LeadType.INSURANCE:
      return 'primary';
    case LeadType.CLAIM:
      return 'danger';
    case LeadType.CANCELLATION:
      return 'zinc';
    case LeadType.POLICY:
      return 'success';
    case LeadType.OFFER_ACCEPTED:
      return 'warning';
    case LeadType.SUBMISSION:
      return 'purple';
    case LeadType.PROPOSAL:
      return 'pink';
    default:
      return '';
  }
};

export const getLeadTypeImportance = (value: LeadType): number => {
  switch (value) {
    case LeadType.INSURANCE:
      return 4;
    case LeadType.CLAIM:
      return 5;
    case LeadType.CANCELLATION:
      return 5;
    case LeadType.POLICY:
      return 6;
    case LeadType.OFFER_ACCEPTED:
      return 5;
    case LeadType.SUBMISSION:
      return 5;
    case LeadType.PROPOSAL:
      return 3;
    default:
      return 0;
  }
};

export const getLeadStatusByProgression = (value: LeadType): LeadStatus[] => {
  switch (value) {
    case LeadType.INSURANCE:
      return Object.values(LeadStatus).filter(
        (x) =>
          x !== LeadStatus.ACCEPTED &&
          x !== LeadStatus.REJECTED &&
          x !== LeadStatus.WAITING_PAIEMENT &&
          x !== LeadStatus.ACTIVE
      );
    // A cancellation has statuses of its own, none of them a lead's.
    case LeadType.CLAIM:
    case LeadType.CANCELLATION:
    case LeadType.POLICY:
      return [];
    case LeadType.OFFER_ACCEPTED:
      return [LeadStatus.ACCEPTED];
    case LeadType.SUBMISSION:
      return [LeadStatus.SENT, LeadStatus.WAITING_PAIEMENT];
    case LeadType.PROPOSAL:
      return [LeadStatus.ACTIVE, LeadStatus.REJECTED];
    default:
      return [];
  }
};
